// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

//Services
import { NavFormsService } from '../../services/navFormsService';

// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CASNavBoxService
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Injectable()
export class CASNavBoxService {
    
    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _actions = [];                                  //Array of actions, which are (form) field objects having type = 'action'
    _actionsLoading = false;
    _allLinksDisabled = false;
    _navForms = [];
    _navLoading = false;
    _userName = "Not Logged In";
    _userInfoString = null;
    _userInfoDetails = [];
    _previousUrl = "";

    //subjects
    _actionClickedSubject = new Subject();
    _anyLinkClickedSubject = new Subject();
    _debugEntryClickedSubject = new Subject();
    _helpLinkClickedSubject = new Subject();
    _actionHelpClickedSubject = new Subject();
    _navigationLoadedSubject = new Subject();
    _navigationLinkClickedSubject = new Subject();

    //Images
    _helpIconSrc = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAVCAIAAADNQonCAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAHfSURBVDhPY/z//z8DLvD14+c/DAwsnLzcbFARbADTiF9vr95Zfe7z9td/30FFQEBLlMvfSMZLWwTKRwKoRry7u2Tdy5mfoDxMwMPH1RakYyjEAuWDAZIRj68Vr/5wCsrBA1grQ/W9ZBFeY4LS7242EKUfCH63r758GMmTECPeH974di+YhQwk+DijFbj8+RihfAT42bDx5mcoG2LEjceT3oN5qEBOQTYjyCBRAeZSJPDr/buNN4CxBQIg6ds3v76A8FDBu3dvzl+8e/7dPygfBfzfeBOqCWjEq9vPsSeNO0/e5e192fgEu+yL55+egxlAI77e+QZmYgAVGaFJzuL1MphhAQbffkHCFIs/4UBISMRQX9lQCJ8aICAgTQwAGsGnxQflkAb4OCTANNAIYW0ZZjCbNKAiwycMZoA8ImnEawbmkAKYQ42kICxIHvlze+PppLvokcfGzCgHzFB//t/5CxWBAzlluaX+MhA2JDhZVP2VKzFC5Nff/3d+YtHPxifQA9MPBPAYEfOKlE7ngnLwADYunhmRWpJQHgigFTlvz6+71/DgN3JhgwzMFMSrgpQhoQgHmKUWA8OPV7dPv9p45/PVTyBf8DAzSvBx+KuImptKSHKgFDYQgM0IkgADAwDOF6Ww6g+oQQAAAABJRU5ErkJggg==";

    //debugging
    _showDebuggingEntries = false;
    _debugEntries = [];                               //Array of strings


    // PUBLIC MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    OnActionClicked$ = this._actionClickedSubject.asObservable();
    OnAnyLinkClicked$ = this._anyLinkClickedSubject.asObservable();
    OnDebugEntryClicked$ = this._debugEntryClickedSubject.asObservable();
    OnHelpLinkClicked$ = this._helpLinkClickedSubject.asObservable();
    OnActionHelpClicked$ = this._actionHelpClickedSubject.asObservable();
    OnNavigationLoaded$ = this._navigationLoadedSubject.asObservable();
    OnNavigationLinkClicked$ = this._navigationLinkClickedSubject.asObservable();


    // GETTERS/SETTERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // Actions (get)
    //==================================
    get Actions(){
        return this._actions;
    };

    //==================================
    // Actions (set)
    //==================================
    set Actions(value){
        setTimeout(()=>{ 
            this._actions = value; 
        }, 0);
    };

    //==================================
    // ActionsLoading (get)
    //==================================
    get ActionsLoading(){
        return this._actionsLoading;
    };

    //==================================
    // ActionsLoading (set)
    //==================================
    set ActionsLoading(value){
        setTimeout(()=>{ this._actionsLoading = value; }, 0);
    }; 

    //==================================
    // AllLinksDisabled (get)
    //==================================
    get AllLinksDisabled(){
        return this._allLinksDisabled;
    };

    ////==================================
    //// AllLinksDisabled (set)
    ////==================================
    //// Note use the DisableAllLinks function if you are not triggering from and Angular detection
    //// sequence and don't want the setTimeout (otherwise the effect may not take place before you
    //// trigger other async operations)
    //set AllLinksDisabled(value){
    //    setTimeout(()=>{ this._allLinksDisabled = value; }, 0);
    //}; 

    //==================================
    // DebugEntries (get)
    //==================================
    get DebugEntries(){
        return this._debugEntries;
    };

    //==================================
    // DebugEntries (set)
    //==================================
    set DebugEntries(value){
        //setTimeout(()=>{ 
            this._debugEntries = value; 
        //}, 0);
    };

    //==================================
    // NavigationForms (get)
    //==================================
    get NavigationForms(){
        return this._navForms;
    };

    //==================================
    // NavigationForms (set)
    //==================================
    //  Pass in an array of forms, where each form must at minimum have the following properties:
    //  form = {
    //      form_display<str>:      ex: "Health Check"
    //      form_route<str>:        ex: "/cpdes/healthcheck"
    //  }
    set NavigationForms(value) {
        this._navForms = value;
        this._navigationLoadedSubject.next(value);
    };

    //==================================
    // NavigationLoading (get)
    //==================================
    get NavigationLoading(){
        return this._navLoading;
    };

    //==================================
    // NavigationLoading (set)
    //==================================
    set NavigationLoading(value){
        setTimeout(()=>{ this._navLoading = value; }, 0);
    }; 

    //==================================
    // ShowDebuggingEntries (get)
    //==================================
    get ShowDebuggingEntries(){
        return this._showDebuggingEntries;
    };

    //==================================
    // ShowDebuggingEntries (set)
    //==================================
    set ShowDebuggingEntries(value){
        setTimeout(()=>{ this._showDebuggingEntries = value; }, 0);
    };

    //==================================
    // UserName (get)
    //==================================
    get UserName(){
        return this._userName;
    };

    //==================================
    // UserName (set)
    //==================================
    set UserName(value){
        setTimeout(()=>{ this._userName = value; }, 0);
    };

    //==================================
    // UserInfoString (get) 
    //==================================
    get UserInfoString(){
        if (this._userInfoString && this._userInfoString == 0){
            return null;
        }
        return this._userInfoString;
    };

    //==================================
    // UserInfoString (set)
    //==================================
    set UserInfoString(value){
        setTimeout(()=>{ this._userInfoString = value; }, 0);
    };
    
    //==================================
    // UserInfoDetails (get)
    //==================================
    // string[]
    get UserInfoDetails(){
        return this._userInfoDetails;
    };

    //==================================
    // UserInfoDetails (set)
    //==================================
    // string[]
    set UserInfoDetails(value){
        setTimeout(()=>{ this._userInfoDetails = value; }, 0);
    };
    

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(navFormsService: NavFormsService) {
        this.constructor.mapParams(this, arguments);

        // NavFormsService.
        this.navFormsService._navigationForms.subscribe((navLinks) => {
            this.NavigationForms = navLinks;
        });
    };


    // FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // ClearActions
    //==================================
    ClearActions(){
        this.Actions = [];
    };

    //==================================
    // ClearDebugEntries
    //==================================
    ClearDebugEntries(){
        this.DebugEntries = [];
    };

    //==================================
    // DeEmphasizeAction
    //==================================
    DeEmphasizeAction(action){

        setTimeout(()=>{ 
            action.__emphasize = false;
        }, 0);        
    };

    //==================================
    // DeEmphasizeActionByName
    //==================================
    DeEmphasizeActionByName(name){

        var action = this.Actions.find(a=>a.field_name == name);
        if (action){
            this.DeEmphasizeAction(action);
        }
    };

    //==================================
    // DisableAction
    //==================================
    DisableAction(action){
        setTimeout(()=>{ 
            action.__enabled = false; 
            action.__emphasize = false;
        }, 0);
    };
    
    //==================================
    // DisableActionByName
    //==================================
    DisableActionByName(name){

        //console.log("    DisableActionByName:", name); 

        let action = this.Actions.find(a=>a.field_name == name);
        if (action){
            this.DisableAction(action);
        }
        else{
            //Best not to do anything if the action is not found
            //throw("[navBoxComm:DisableActionByName] Action not found: " + name);
        }
    };

    //==================================
    // DisableActionHelpIcon
    //==================================
    DisableActionHelpIcon(action){
        setTimeout(()=>{ 
            action.__showHelpIcon = false; 
        }, 0);
    };

    //==================================
    // DisableActionHelpIconByName
    //==================================
    DisableActionHelpIconByName(name){
        var action = this.Actions.find(a=>a.field_name == name);
        if (action){
            this.DisableActionHelpIcon(action);
        }
    };

    //==================================
    // DisableAllLinks
    //==================================
    DisableAllLinks(bUseTimeout){
        
        if (bUseTimeout){
            setTimeout(()=>{ this._allLinksDisabled = true; }, 0);
        }
        else{
            this._allLinksDisabled = true;
        }
    };

    //==================================
    // EmitActionClicked
    //==================================
    EmitActionClicked(action){
        
        //Jump out if this action is not currently enabled
        if (!this.IsActionEnabled(action)){ return; }

        this._actionClickedSubject.next(action);
        this.EmitAnyLinkClicked();
    };

    //==================================
    // EmitActionHelpClicked
    //==================================
    EmitActionHelpClicked(action){
        this._actionHelpClickedSubject.next(action);
    };

    //==================================
    // EmitAnyLinkClicked
    //==================================
    EmitAnyLinkClicked(){
        
        //Jump out if links are currently disabled
        //  (when a navlink is clicked on the navbox, the handler in cas-navbox.js will issue a router.navigate.  Before that
        //  however, it will call EmitAnyLinkClicked() in case any listeners need to respond [i.e. navBox will be hidden on click,
        //  which might only really matter if pages aren't changed])
        if (this.AllLinksDisabled) { return; }

        this._anyLinkClickedSubject.next(null);
    };

    //==================================
    // EmitDebugEntryClicked
    //==================================
    EmitDebugEntryClicked(entry){
    
        //Jump out if debug links are disabled (they don't have a one-off setting for disabling)
        if (this.AllLinksDisabled) { return; }

        this._debugEntryClickedSubject.next(entry);
        this.EmitAnyLinkClicked();
    }

    //==================================
    // EmitHelpLinkClicked
    //==================================
    EmitHelpLinkClicked(link){
    
        //Never disabled

        //Not sure if the "any link" handling is sensible here.  Leaving it for now.
        this._helpLinkClickedSubject.next(link);
        this.EmitAnyLinkClicked();
    }

    //==================================
    // EmitNavigationLinkClicked
    //==================================
    EmitNavigationLinkClicked(form){
        
        //Jump out if debug links are disabled (they don't have a one-off setting for disabling)
        if (this.AllLinksDisabled) { return; }

        this._navigationLinkClickedSubject.next(form);
        this.EmitAnyLinkClicked();
    };

    //==================================
    // EmphasizeAction
    //==================================
    EmphasizeAction(action){

        setTimeout(()=>{ 
            action.__emphasize = true;
        }, 0);        
    };

    //==================================
    // EmphasizeActionByName
    //==================================
    EmphasizeActionByName(name){

        var action = this.Actions.find(a=>a.field_name == name);
        if (action){
            this.EmphasizeAction(action);
        }
    };

    //==================================
    // EnableAction
    //==================================
    //  bEmphasize<bool>:       //(opt, false) When true, the link will not just be enabled, but bolded as well.
    //                          //This was intended for use with "save" actions we want to make sure are higly visible.
    EnableAction(action, bEmphasize){
        setTimeout(()=>{ 
            action.__enabled = true; 
            action.__emphasize = !!bEmphasize;
        }, 0);
    };

    //==================================
    // EnableActionByName
    //==================================
    //  bEmphasize<bool>:       //(opt, false) When true, the link will not just be enabled, but bolded as well.
    //                          //This was intended for use with "save" actions we want to make sure are higly visible.
    EnableActionByName(name, bEmphasize){
    
        //console.log("    EnableActionByName:", name);

        var action = this.Actions.find(a=>a.field_name == name);
        if (action){
            //setTimeout(()=>{ action.__enabled = true; }, 0);
            this.EnableAction(action, bEmphasize);
        }
        else{
            //Best not to do anything if the action is not found
            //throw("[navBoxComm:EnableActionByName] Action not found: " + name);
        }
    };

    //==================================
    // EnableActionHelpIcon
    //==================================
    EnableActionHelpIcon(action){
        setTimeout(()=>{ 
            action.__showHelpIcon = true; 
        }, 0);
    };

    //==================================
    // EnableActionHelpIconByName
    //==================================
    EnableActionHelpIconByName(name){
        var action = this.Actions.find(a=>a.field_name == name);
        if (action){
            this.EnableActionHelpIcon(action);
        }
    };

    //==================================
    // EnableAllLinks
    //==================================
    EnableAllLinks(bUseTimeout){
        
        if (bUseTimeout){
            setTimeout(()=>{ this._allLinksDisabled = false; }, 0);
        }
        else{
            this._allLinksDisabled = false;
        }
    };

    //==================================
    // HideAction
    //==================================
    HideAction(action) {
        setTimeout(() => {
            action.__enabled = false;
            action.__emphasize = false;
            action.__hidden = true;
        }, 0);
    };

    //==================================
    // HideActionByName
    //==================================
    HideActionByName(name) {

        let action = this.Actions.find(a => a.field_name == name);
        if (action) {
            this.HideAction(action);
        }
        else {
            //Best not to do anything if the action is not found
        }
    };

    //==================================
    // IsActionEmphasized
    //==================================
    IsActionEmphasized(action){
        return !!action.__emphasize;
    };

    //==================================
    // IsActionEnabled
    //==================================
    IsActionEnabled(action){
        return !this.AllLinksDisabled && !!action.__enabled;
    };

    //==================================
    // IsActionHelpIconEnabled
    //==================================
    IsActionHelpIconEnabled(action){
        return !!action.__showHelpIcon;
    };

    //==================================
    // IsActionHidden
    //==================================
    IsActionHidden(action) {
        return action.__hidden;
    };

    //==================================
    // SetActionEnabledByName
    //==================================
    //  bEnabled<bool>:         //(opt, false) Set false to disable action, true to enabled it
    //  bEmphasize<bool>:       //(opt, false) When true, the link will not just be enabled, but bolded as well.
    //                          //This was intended for use with "save" actions we want to make sure are higly visible.
    SetActionEnabledByName(name, bEnabled, bEmphasize){
        
        bEnabled = !!bEnabled;
        bEmphasize = !!bEmphasize;

        var action = this.Actions.find(a=>a.field_name == name);
        if (action){
            if (bEnabled){
                this.EnableAction(action, bEmphasize);
            }
            else{
                this.DisableAction(action);
            }
        }
    };

    //==================================
    // ShowAction
    //==================================
    ShowAction(action) {
        setTimeout(() => {
            action.__enabled = true;
            action.__hidden = false;
        }, 0);
    };

    //==================================
    // ShowActionByName
    //==================================
    ShowActionByName(name) {

        let action = this.Actions.find(a => a.field_name == name);
        if (action) {
            this.ShowAction(action);
        }
        else {
            //Best not to do anything if the action is not found
        }
    };


}


